import React from 'react';
import styled from 'styled-components';
import Modal from '..';
import { ReactComponent as AlertIcon } from '../../../assets/icons/alert.svg';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: -24px;

  .title {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 24px;
    text-align: center;

    color: #0e185b;
    margin-top: 20px;
  }
  .message {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    color: #222222;
    margin-top: 12px;
  }
  .button {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: center;
    color: #ffffff;

    background: ${({ theme }) => theme.colors.primary};
    box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${props.theme.borderRadius}px`
        : '16px'};
    margin-top: 24px;
    padding: 20px 24px;
  }
`;

const NetworkError = () => {
  const handleClose = () => {
    if (/contato/.test(window.location.pathname)) {
      return window.location.replace('/');
    }
    window.location.reload();
  };
  return (
    <Modal title='' width='464px' handlerClose={handleClose}>
      <Content>
        <AlertIcon />
        <h1 className='title'>Erro de Conexão</h1>
        <p className='message'>
          Não foi possível conectar com o servidor. Tente novamente ou aguarde
          um pouco.
        </p>
        <button className='button' onClick={handleClose}>
          TENTAR NOVAMENTE
        </button>
      </Content>
    </Modal>
  );
};

export default NetworkError;
